import React from 'react';
import { RouteComponentProps } from 'react-router';
import { EducationListContainer } from '../../epic/education-list';

export const Page: React.FC<RouteComponentProps> = () => {
  return <EducationListContainer />;
};
